/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highres_DocumentInputs */

const en_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-Res Document`)
};

const es_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento de alta resolución`)
};

const fr_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document haute résolution`)
};

const de_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochauflösendes Dokument`)
};

const ja_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高解像度ドキュメント`)
};

const zh_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高分辨率文档`)
};

const ar_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستند عالي الدقة`)
};

const id_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen Resolusi Tinggi`)
};

const it_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento in Alta Risoluzione`)
};

const ru_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Документ высокого разрешения`)
};

const pt_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento em Alta Resolução`)
};

const ko_highres_document = /** @type {(inputs: Highres_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고해상도 문서`)
};

/**
* | output |
* | --- |
* | "High-Res Document" |
*
* @param {Highres_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const highres_document = /** @type {((inputs?: Highres_DocumentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highres_DocumentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_highres_document(inputs)
	if (locale === "es") return es_highres_document(inputs)
	if (locale === "fr") return fr_highres_document(inputs)
	if (locale === "de") return de_highres_document(inputs)
	if (locale === "ja") return ja_highres_document(inputs)
	if (locale === "zh") return zh_highres_document(inputs)
	if (locale === "ar") return ar_highres_document(inputs)
	if (locale === "id") return id_highres_document(inputs)
	if (locale === "it") return it_highres_document(inputs)
	if (locale === "ru") return ru_highres_document(inputs)
	if (locale === "pt") return pt_highres_document(inputs)
	return ko_highres_document(inputs)
});